(function ($) {
  $(document).ready(function () {
    bindEventsOnReadyAndAjaxStop();

    // Initialize the header.
    initHeader();

    // Initialize the footer.
    initFooter();

    // Padding of page content
    initPageContentPadding();

    // Initialize the left menu.
    // initLeftMenu();

    // Toggle the footer.
    $(document).on('click', '.footer-anchor', function (event) {
      event.preventDefault();

      $('#page-footer').toggleClass('unfold');
    });

    // Toggle the header menu.
    $(document).on(
      'click',
      '.navbar-header .toggle-navigation',
      function (event) {
        event.preventDefault();

        $(this).closest('.navbar-header').toggleClass('in');
      }
    );

    // Toggle menu items.
    $(document).on(
      'click',
      '.navigation-menu .toggle-children',
      function (event) {
        event.preventDefault();

        $(this).closest('.menu-item').toggleClass('in');
      }
    );
  });

  $(document).ajaxStop(function () {
    bindEventsOnReadyAndAjaxStop();
  });

  $(window).scroll(function () {
    initHeader();
  });

  $(window).resize(function () {
    initPageContentPadding();
  });

  function bindEventsOnReadyAndAjaxStop() {
    // Bootstrap Tooltip
    $('[data-toggle="tooltip"]').tooltip();
  }

  function initHeader() {
    var $header = $('#page-header');
    var scrollAmount = 70; // Equal to height of the navigation menu.

    if (
      $(window).width() > CmtaFw.mobileBreakPoint &&
      $('.page-header-top').length
    ) {
      if ($(document).scrollTop() > scrollAmount) {
        $header.addClass('fixed');
      } else {
        $header.removeClass('fixed');
      }
    } else {
      $header.removeClass('fixed');
    }
  }

  function initFooter() {
    var $targets = [$('#page-content')];

    if ($('body').hasClass('header-style-slideshow')) {
      $targets.push($('.page-presentation'));
    }
  }

  function initPageContentPadding() {
    var $header = $('#page-header');
    var $content = $('#page-content');

    if ($(window).width() > CmtaFw.mobileBreakPoint) {
      $content.css({ paddingTop: '' });
    } else if (!$('body').hasClass('header-style-slideshow')) {
      $content.css({
        paddingTop: function () {
          return $header.outerHeight();
        },
      });
    }
  }

  function initLeftMenu() {
    var $currentMenuItems = $(
      '.navigation-menu-top .menu-item.current-menu-item'
    );

    if (!$currentMenuItems.length) {
      return;
    }

    $currentMenuItems.each(function () {
      if ($(this).hasClass('menu-item-has-children')) {
        $(this).addClass('in');
      }

      $(this).parents('.menu-item').addClass('in');
    });
  }


  //Check if the previous page is customer research and is so open search.
  if (sessionStorage.getItem('url') != null) {
    const currentPage = location.href.split('/');
    const previousPage = sessionStorage.getItem('url').split('/');
    if (
      previousPage[3] === "customer-research"
      && currentPage[3] !== "customer-research"
      && window.history
      && window.history.pushState) {
      $('#search').attr('open','');
      sessionStorage.clear();
    }
    window.addEventListener("pageshow", () => {
    if(
      currentPage[3] === "customer-research"){
        if($('.crt-traveler-row input:checkbox').is(':checked')){
          $('.crt-traveler-row input:checkbox').prop( "checked", false );
          sessionStorage.clear();
        }
      }
    });
  }

  //Check if the previous page is customer research and if the user ended its research.
  if (sessionStorage.getItem('researchEnded') != null) {
    window.addEventListener("pageshow", () => {
      $('#search-form')[0].reset();
    });
    sessionStorage.clear()
  }

  // Load the reservation form.
  $(document).on(
    'click',
    '.navigation-menu .menu-item-reservation > a',
    function (event) {
      event.preventDefault();

      var $this = $(this),
        $menuItem = $('.menu-item-reservation');

      if ($this.hasClass('disabled')) {
        return;
      }

      if (!$menuItem.hasClass('is-loaded')) {
        $menuItem.addClass('is-loaded is-opened');
        $('#reservation').addClass('display');
        if ($('#reservation-form').length) {
          var $form = $('#reservation-form');

          originalFormState = $form.serialize();
        }
      }else {
        $menuItem.toggleClass('is-opened');
        $('#reservation').toggleClass('display');
      }
    });
})(jQuery);
